// extracted by mini-css-extract-plugin
export default {"centered":"_1WG3Y","unsubscribe-width":"_3sVor","unsubscribeWidth":"_3sVor"};